module.exports = __webpack_public_path__ + "static/img/products application_Tape PVC3.b6edf734.jpg";